import {
    HOMEPAGE_SETTINGS_UPLOAD_START,
    HOMEPAGE_SETTINGS_UPLOAD_ERROR,
    HOMEPAGE_SETTINGS_UPLOAD_SUCCESS
} from '../../constants/index'
import { setLoaderStart, setLoaderComplete } from '../loader/loader';
import { updateHomePageFooterMutation } from '../../lib/graphql';
import showToaster from '../../helpers/toastrMessgaes/showToaster';

const updateHomepageSettingsFooter = (values) => {

    return async (dispatch, getState, { client }) => {

        try {
            dispatch({
                type: HOMEPAGE_SETTINGS_UPLOAD_START
            })

            let title, description, urlTitle;

            title = values?.footerTitle1.length && values?.footerTitle1[0]?.value;
            description = values?.footerTitle1.length && values?.footerTitle1[0]?.description;
            urlTitle = values?.footerTitle1.length && values?.footerTitle1[0]?.urlTitle;

            dispatch(setLoaderStart('FooterSettingsForm'))
            const { data } = await client.mutate({
                mutation: updateHomePageFooterMutation,
                variables: {
                    footerLogo1: values?.footerLogo1,
                    footerLogo2: values?.footerLogo2,
                    footerLogo3: values?.footerLogo3,
                    footerLogo4: values?.footerLogo4,
                    footerTitle1: title,
                    footerContent1: description,
                    footerLink1: values?.footerLink1,
                    footerLink2: values?.footerLink2,
                    footerLink3: values?.footerLink3,
                    footerLink4: values?.footerLink4,
                    footerLinkName1: values?.footerLinkName1,
                    footerLinkName2: values?.footerLinkName2,
                    footerLinkName3: values?.footerLinkName3,
                    footerLinkName4: values?.footerLinkName4,
                    footerLinkTitle: urlTitle,
                    footerBottom: values?.footerBottom,
                    dynamicFooterSettings: values?.footerTitle1
                }
            })

            dispatch(setLoaderComplete('FooterSettingsForm'))
            if (data?.updateHomePageFooter?.status == 200) {
                dispatch({
                    type: HOMEPAGE_SETTINGS_UPLOAD_SUCCESS
                });
                showToaster({ messageId: 'updateFooterSuccess', toasterType: 'success' });
            } else {
                dispatch({
                    type: HOMEPAGE_SETTINGS_UPLOAD_ERROR
                });
                showToaster({ messageId: 'errorMessage', requestContent: data?.updateHomePageFooter?.errorMessage, toasterType: 'error' });
            }
        } catch (err) {
            dispatch({
                type: HOMEPAGE_SETTINGS_UPLOAD_ERROR
            })
            showToaster({ messageId: 'catchMessage', requestContent: err, toasterType: 'error' });
        }

    }
}

export default updateHomepageSettingsFooter;